package gr.tech.GRAttestation.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.components.inputs.StringInput
import gr.tech.GRAttestation.components.inputs.ValidationTrigger
import gr.tech.GRAttestation.components.layouts.StoreUserPageLayout
import gr.tech.GRAttestation.components.widgets.loadingSpinner
import gr.tech.GRAttestation.infrastructure.api.userGetResetPasswordEmail
import gr.tech.GRAttestation.navigation.SitePage
import gr.tech.GRAttestation.styles.*
import gr.tech.GRAttestation.styles.grstyles.Theme
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.onSubmit
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Form
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page(routeOverride = "forgot-password")
@Composable
fun ForgotPasswordPage() {
    StoreUserPageLayout(
        title = "Forgot Password",
        requiredRoles = emptyList()
    ) {
        ForgotPasswordScreen()
    }
}

@Composable
fun ForgotPasswordScreen() {
    val scope = rememberCoroutineScope()

    var submitPressed by remember { mutableStateOf(false) }
    var emailInput by remember { mutableStateOf("") }
    var emailSent by remember { mutableStateOf(false) }
    var errorText by remember { mutableStateOf("") }

    fun handleSubmit() {
        if (emailInput.isNotBlank() && !submitPressed) {
            submitPressed = true
            scope.launch {
                val response = userGetResetPasswordEmail(emailInput.trim().lowercase())
                if (response.success) {
                    emailSent = true
                } else {
                    errorText = "Something went wrong. Please try again."
                }
                submitPressed = false
            }
        }
    }

    Box(
        modifier = AuthBoxStyle.toModifier(),
        contentAlignment = Alignment.Center
    ) {
        Column(modifier = AuthCardStyle.toModifier()) {
            // Card Header
            Column(
                modifier = AuthCardHeaderStyle.toModifier(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Image(
                    src = "/grlogocenter.png",
                    alt = "Green Rebates Logo",
                    modifier = AuthLogoStyle.toModifier()
                )

                H2(attrs = AuthTitleStyle.toModifier().toAttrs()) {
                    Text("Forgot Password")
                }

                P(attrs = AuthSubtitleStyle.toModifier().toAttrs()) {
                    Text("ETO Grow Light Fixture Program 2026")
                }
            }

            // Card Body
            Form(
                attrs = Modifier
                    .fillMaxWidth()
                    .padding(24.px, 26.px)
                    .toAttrs {
                        onSubmit {
                            it.preventDefault()
                            handleSubmit()
                        }
                    }
            ) {
                when (emailSent) {
                    false -> {
                        StringInput(
                            direction = FlexDirection.Column,
                            inputId = "ForgotPasswordEmailInput",
                            labelText = "EMAIL",
                            value = emailInput,
                            hasError = false,
                            showError = false,
                            placeholder = "store@email.com",
                            labelError = "",
                            labelModifier = AuthLabelStyle.toModifier(),
                            inputModifier = AuthInputStyle.toModifier().margin(bottom = 20.px),
                            minLength = 1,
                            maxLength = 254,
                            validationTrigger = ValidationTrigger.OnChange,
                            onValueChange = { value ->
                                emailInput = value
                            }
                        )

                        if (errorText.isNotEmpty()) {
                            P(attrs = AuthErrorStyle.toModifier().margin(bottom = 12.px).toAttrs()) {
                                Text(errorText)
                            }
                        }

                        Button(
                            colorPalette = null,
                            enabled = !submitPressed,
                            modifier = AuthButtonStyle.toModifier()
                                .width(100.percent)
                                .padding(12.px),
                            type = ButtonType.Submit,
                            onClick = { }
                        ) {
                            if (submitPressed) {
                                loadingSpinner(modifier = Modifier.color(Colors.White))
                            } else {
                                SpanText(
                                    text = "Send Reset Link",
                                    modifier = Modifier.fontSize(14.px).fontWeight(600)
                                )
                            }
                        }
                    }

                    true -> {
                        P(attrs = AuthSubtitleStyle.toModifier().margin(bottom = 20.px).toAttrs()) {
                            Text("If an account with that email exists, a password reset link has been sent.")
                        }
                    }
                }

                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(top = 20.px),
                    contentAlignment = Alignment.Center
                ) {
                    Link(
                        text = "Back to Login",
                        path = SitePage.Login.route,
                        modifier = Modifier
                            .fontSize(0.75.cssRem)
                            .color(Theme.DarkGreen.rgb)
                    )
                }
            }
        }
    }
}
